<template>
  <div class="model_container">
    <el-form :model="carForm"
             label-position="top"
             action="javascript:void(0)">
      <el-form-item label="文案类型"
                    size="small">

        <el-radio-group @change="searchCarCropus(1, true)"
                        v-model="carForm.tag">
          <el-radio-button label="CARDESC">车型描述</el-radio-button>
          <el-radio-button label="SUBTITLE">小标题</el-radio-button>
          <el-radio-button label="CARAD">广告词</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <template v-if="carForm.tag === 'CARDESC'">
        <el-form-item label="车型选择">
          <el-select v-model="carForm.carId"
                     @change="searchCarCropus(1)"
                     placeholder="请选择车型">
            <el-option v-for="item in carTypes"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述标签">
          <el-select v-model="carForm.carDescType"
                     @change="searchCarCropus(1)"
                     placeholder="描述标签">
            <el-option v-for="item in carDescTags"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </template>

      <template v-if="carForm.tag === 'SUBTITLE'">
        <el-form-item label="标题标签">
          <el-select v-model="carForm.subTitleType"
                     @change="searchCarCropus(1)"
                     placeholder="标题标签">
            <el-option v-for="item in carTitleTags"
                       :key="item"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="carForm.tag === 'SUBTITLE'">
        <el-form-item label="小标题搜索">
          <el-input placeholder="输入关键词"
                    v-model="carForm.searchWord"
                    clearable
                    @clear="searchCarCropus(1)">
          </el-input>
        </el-form-item>
      </template>
      <template v-if="carForm.tag === 'CARAD'">
        <el-form-item label=" 广告词搜索">
          <el-input placeholder="输入关键词"
                    v-model="carForm.searchWord"
                    clearable
                    @clear="searchCarCropus(1)">
          </el-input>
        </el-form-item>
      </template>
      <el-form-item style="display:none">
        <el-button type="primary"
                   native-type="submit"
                   @click="searchCarCropus(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <div class="scrollContainer"
           style="overflow-y: scroll;height: calc(100vh - 380px); margin-top: 15px;">
        <div class="infinite-list"
             v-infinite-scroll="searchMoreCarCropus"
             :infinite-scroll-distance=500
             :infinite-scroll-delay=300
             :infinite-scroll-immediate=true
             :infinite-scroll-disabled='searchCarCropusFinish'>
          <el-col v-for="( item, index ) in  carSearchRes "
                  :key="index"
                  :span="24">
            <el-card shadow="hover"
                     class="article_card">
              {{ item.itemText }}
              <el-col :span="24"
                      class="article_card_time"
                      style="text-align:right;padding-right: 15px;margin-top: 10px;">
                <el-link :underline="false"
                         @click="insert(item.itemText)">
                  <span style="font-size: 11.56px;font-weight: 400;color: rgba(75, 140, 247, 1);">
                    插入正文
                  </span>
                </el-link>
                <br> <br>
              </el-col>
            </el-card>
            <br>
          </el-col>

          <div style="clear:both"></div>
          <template>

            <template v-if="searchCarCropusFinish">
              <template v-if="carSearchRes && carSearchRes.length > 0">
                <div class="noData">
                  <i class="iconfont">&#xe629;</i>
                  数据加载完毕!
                </div>
              </template>
              <template v-else>
                <div class="noData">
                  未查询到数据。
                </div>
              </template>
            </template>
            <template v-else>
              <div class="noData">
                <span class="icon_run">
                  <i class="iconfont">&#xe67b;</i>
                </span>数据加载中...
              </div>

            </template>
          </template>

        </div>
      </div>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'carTab',
  props: ['article', 'articleInfo', 'carId'],
  data () {
    return {
      carTypes: [],
      carForm: {
        carId: '',
        carDescType: '',
        subTitleType: '',
        tag: 'CARDESC',
        searchWord: '',
        page: 1,
        pageSize: 10
      },
      carSearchRes: [],
      carDescTags: [],
      carTitleTags: [],
      sentenceForm: {
        searchType: 'FIRSTP',
        sentence: ''
      },
      searchSentenceRes: {},
      searchCarCropusFinish: false
    }
  },
  mounted () {
    let _this = this
    this.carForm.carId = this.carId
    this.axios.get('/webApi/carType/listAll').then(resp => {
      _this.carTypes = resp.data.list
      if (_this.carForm.carDescType) {
        _this.searchCarCropus()
      }
    })
    this.axios.get('/webApi/carCropus/carDesctypes').then(resp => {
      _this.carDescTags = resp.data
      _this.carForm.carDescType = resp.data[0]
      _this.searchCarCropus()
    })
    this.axios.get('/webApi/carCropus/subTitleTypes').then(resp => {
      _this.carTitleTags = resp.data
      _this.carForm.subTitleType = resp.data[0]
    })
  },
  components: {

  },
  methods: {
    insert (val) {
      this.$emit('insert', val)
    },
    searchMoreCarCropus () {
      this.carForm.page = this.carForm.page + 1
      this.searchCarCropus(this.carForm.page)
    },
    searchCarCropus (page, isChnage) {
      if (isChnage) {
        this.carForm.searchWord = ''
      }
      if (!this.carForm.carId || !this.carForm.carDescType) {
        this.searchCarCropusFinish = true
        return
      }
      if (page) {
        this.carForm.page = page
      }
      if (this.carForm.page === 1) {
        this.carSearchRes = []
        this.searchCarCropusFinish = false
      }
      let _this = this
      this.axios.post('/webApi/carCropus/listByPage', this.carForm).then(resp => {
        _this.carSearchRes.push.apply(_this.carSearchRes, resp.data.rows)
        if (resp.data.rows && resp.data.rows.length < 10) {
          _this.searchCarCropusFinish = true
        }
      })
    }
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/article/carTab.vue